import { FC } from 'react'
import styled, { css } from 'styled-components'
import { ArrowRight } from 'svgIcons'
import Button from '@app.components/Button'

interface IFJobCategoryButtonProps {
  count: number
  onClick: () => void
  className?: string
}

const JobCategoryButton: FC<IFJobCategoryButtonProps> = ({
  count,
  onClick,
  className,
}) => {
  return (
    <StyledWrapper color="transparent" onClick={onClick} className={className}>
      <span>모집직무</span>
      {count > 0 && <span className="count">{count}</span>}
      <ArrowRight className="arrow-right" />
    </StyledWrapper>
  )
}

export default JobCategoryButton

const StyledWrapper = styled(Button)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    width: 100%;
    height: 50px;
    border: 1px solid ${theme.line.line_1}
    padding: 15px 20px;
    font-size: 14px;
    font-weight: 500;

    :has(.count) {
      border-color: ${theme.color.primary_2};
    }

    .count {
      margin-left: 5px;
      font-weight: bold;
      color: ${theme.color.primary_2};
      margin-bottom: 1px;
    }

    .arrow-right {
      margin-left: auto;
      width: 10px;
      height: 10px;
    }
  `}
`
